import { Link } from "react-router-dom";
import { AppContext } from "../../AppContext";
import { useContext } from "react";
import HTMLReactParser from "html-react-parser";
import { useState } from "react";

const TrendingV3 = () => {
  const publicUrl = process.env.PUBLIC_URL + "/";
  const { sendClickStatus, podcasts } = useContext(AppContext);
  const { users } = useContext(AppContext);
  const [activeVideoId, setActiveVideoId] = useState(null);

  const truncate = (str, n) => (str.length > n ? str.slice(0, n) + "..." : str);
  // 🔸 Helper function: exact same logic as CatSports
  const getFilteredPosts = (category, start, end) => {
    return users
      .filter(
        (user) =>
          (user.post_type === "post" && user.category_name === category) ||
          (user.post_type === "New" && user.cat === category)
      )
      .filter((post) => {
        if (post.post_type === "post") {
          return users.some(
            (img) =>
              img.post_type === "attachment" && img.post_parent === post.ID
          );
        } else {
          return true;
        }
      })
      .map((post) => {
        let imageUrl = "";

        if (post.post_type === "post") {
          const image = users.find(
            (img) =>
              img.post_type === "attachment" && img.post_parent === post.ID
          );
          imageUrl = image ? image.guid : "";
        } else if (post.post_type === "New") {
          imageUrl = "https://hondaapi.clientcoding.com/" + post.guid;
        }

        return {
          id: post.ID,
          title: post.post_title,
          content: post.post_content,
          image: imageUrl,
          author: post.post_type === "New" ? post.author : post.author_name,
          category: post.post_type === "New" ? post.cat : post.category_name,
          post_date_gmt: post.post_date_gmt,
        };
      })
      .slice(start, end);
  };
  const [activeVideo, setActiveVideo] = useState(null);



  // Helper to convert full YouTube link to embeddable format
  const getYoutubeEmbedUrl = (url) => {
    const videoIdMatch = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([^\s&?/]+)/
    );
    return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : null;
  };


  const filteredPost1 = getFilteredPosts("न्यूज़", 0, 5);
  const filteredPostsManoranj = getFilteredPosts("धर्म", 0, 1);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };
  const filteredPosts = Array.isArray(podcasts) ? podcasts : [];
  return (
    <div className="post-area pd-top-75 bg-sky pd-bottom-50 go-top">
      <div className="container">
        <div className="row">
          {/* Column 1 */}
          <div className="col-lg-3 col-md-6">
            <div className="section-title ">
              <h6 className="title black">रुबरू <span className="with" style={{ textTransform: "lowercase" }}>With</span> राजीव</h6>

            </div>
            <div className="item">
            
             {Array.isArray(podcasts) && podcasts.slice(0, 2).map((video) => (
        <div
          className="single-post-wrap style-overlay mb-3"
          key={video.id}
          style={{ cursor: "pointer" }}
        >
          {/* If this video is active, show iframe */}
          {activeVideoId === video.id ? (
            <iframe
              width="100%"
              height="200"
              style={{maxHeight:"220px"}}
              src={getYoutubeEmbedUrl(video.youtube_link)}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div onClick={() => setActiveVideoId(video.id)}>
              <div className="thumb">
                <img
                  src={`https://hondaapi.clientcoding.com/${video.thumbnail}`}
                  alt={video.title}
                  style={{ maxWidth: "100%", objectFit: "cover" }}
                  height={150}
                />
              </div>
              <div className="details">
                <Link to="/रुबरू-with-राजीव"><h6 className="title mt-2 mb-4 black">{video.title.slice(0, 50)}...</h6></Link>
              </div>
            </div>
          )}
        </div>
      ))}
            </div>


          </div>



          {/* Column 2 */}
          <div className="col-lg-3 col-md-6">
            <div className="section-title">
              <h6 className="title black">न्यूज़</h6>
            </div>
            <div className="item">
              {filteredPost1.map((post) => (
                <div className="single-post-list-wrap" key={post.id}>
                  <div className="media">
                    <div className="media-left">
                      <img
                        src={post.image}
                        alt={post.title}
                        style={{ maxWidth: "100%", objectFit: "cover" }}
                        height={85}
                        width={120}
                      />
                    </div>
                    <div className="media-body">
                      <div className="details">
                        <div className="post-meta-single ">
                          <ul>
                            <li className="black">
                              <i className="fa fa-clock-o" />
                              {formatDate(post.post_date_gmt)}
                            </li>
                          </ul>
                        </div>
                        <h6 className="title">
                          <Link to={`/news-details/${post.id}`} onClick={() => {
                            sendClickStatus(post.id, "click");
                          }}>
                            {truncate(post.title, 53)}
                          </Link>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Column 3 */}
          <div className="col-lg-3 col-md-6">
            <div className="section-title">
              <h6 className="title black">मनोरंजन</h6>
            </div>
            {filteredPostsManoranj.map((post) => (
              <div className="item" key={post.id}>
                <div className="single-post-wrap">
                  <div className="thumb">
                    <img
                      src={post.image}
                      alt={post.title}
                      style={{
                        maxWidth: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      height={232}
                    />
                  </div>
                  <div className="details">
                    <div className="post-meta-single mb-4 pt-1">
                      <ul>
                        <li>
                          <Link
                            className="tag-base tag-blue"
                            to={`/category/${post.category}`}
                            onClick={() => {
                              sendClickStatus(post.id, "click");
                            }}>
                            {post.category}
                          </Link>
                        </li>
                        <li>
                          <i className="fa fa-clock-o" />
                          {formatDate(post.post_date_gmt)}
                        </li>
                      </ul>
                    </div>
                    <h6 className="title">
                      <Link to={`/news-details/${post.id}`} onClick={() => {
                        sendClickStatus(post.id, "click");
                      }}>
                        {truncate(post.title, 53)}
                      </Link>
                    </h6>
                    {HTMLReactParser(post.content?.substring(0, 180))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Column 4 */}
          <div className="col-lg-3 col-md-6">
            <div className="section-title">
              <h6 className="title">Join With Us</h6>
            </div>
            <div className="social-area-list mb-4">
              <ul>
                <li>
                  <a
                    className="facebook"
                    href="https://www.facebook.com/WeRNews/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-facebook social-icon" />
                    <span>88,000</span>
                    <span>Like</span> <a href="https://www.facebook.com/WeRNews/" target="_blank"><i className="fas fa-arrow-right" /></a>
                  </a>
                </li>
                <li>
                  <a
                    className="twitter"
                    href="https://x.com/WeRNewsLive"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-x-twitter social-icon" />
                    <span>121</span>
                    <span>Followers</span> <a href="https://x.com/WeRNewsLive" target="_blank"><a href="" target="_blank"><i className="fas fa-arrow-right" /></a></a>
                  </a>
                </li>
                <li>
                  <a
                    className="youtube"
                    href="https://www.youtube.com/@WeRNewsLive"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-youtube-play social-icon" />
                    <span>3,640</span>
                    <span>Subscribers</span> <a href="https://www.youtube.com/@WeRNewsLive" target="_blank"><i className="fas fa-arrow-right" /></a>
                  </a>
                </li>
                <li>
                  <a
                    className="instagram"
                    href="https://www.instagram.com/wernewslive/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa fa-instagram social-icon" />
                    <span>648</span>
                    <span>Followers</span> <a href="https://www.instagram.com/wernewslive/" target="_blank"><i className="fas fa-arrow-right" /></a>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendingV3;
